module.exports = __webpack_public_path__ + "img/car-crash.ebf1764b.svg";